import cn from 'bem-cn';

import { Stack } from '../UI';
import { formatRussianDate } from '../../utils/date/date';

import { PromptInfoStatistics } from './PromptInfoStatistics';
import { PromptInfoHeader } from './PromptInfoHeader';
import { PromptInfoBody } from './PromptInfoBody';
import { PromptInfoAuthor } from './PromptInfoAuthor';
import { PromptInfoProps } from './PromptInfo.types';
import './PromptInfo.scss';

const b = cn('prompt-info');

export const PromptInfo = (props: PromptInfoProps) => {
    const { prompt, onLikeClick, onShareClick, isMediaPrompt } = props;
    const {
        likes,
        isLiked,
        visits,
        imageData,
        title,
        description,
        categories,
        promptForExample,
        example,
        exampleImage,
        videoData,
        author,
        createdAt,
    } = prompt;
    const formattedDate = formatRussianDate(createdAt);

    return (
        <Stack className={b({ mediaprompt: isMediaPrompt })}>
            <PromptInfoHeader
                image={imageData.urlOptimized}
                title={title}
                description={description}
                categories={categories}
            />
            <PromptInfoStatistics
                likes={likes}
                isLiked={isLiked}
                views={visits}
                onLikeClick={onLikeClick}
                onShareClick={onShareClick}
            />
            <PromptInfoBody
                data={{
                    promptImage: imageData.urlOptimized,
                    promptForExample,
                    example,
                    exampleImage,
                    exampleVideo: videoData.url,
                    isMediaPrompt,
                }}
            />
            {<PromptInfoAuthor author={author} subtitle="Автор" />}
            <p className={b('created-at')}>Опубликовано: {formattedDate}</p>
        </Stack>
    );
};
